module.exports = "/images/food.svg?f620a25e8eee5e9275cbd714153d57d3";